import * as React from "react";
import { Component } from "react";
import { Button, Glyphicon, Table } from "react-bootstrap";
import LoadingStatus from "src/components/common/LoadingStatus";
import "src/css/components/projects/projects.css";
import { IProject, IProjectsProps, IProjectsState } from "./interfaces";

export default class Projects extends Component<IProjectsProps, IProjectsState> {
  public constructor(props: IProjectsProps) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    if (this.state.loading) {
      return <LoadingStatus text="Loading..." />;
    }
    const { projects } = this.props;
    return (
      <div className="container projects-grid">
        <Table id="projects" striped={true} condensed={true}>
          <colgroup>
            <col width="225" />
          </colgroup>
          <thead>
            <tr>
              <th id="projects_ActionHeader">Actions</th>
              <th id="projects_LocationHeader">Location</th>
            </tr>
          </thead>
          <tbody>
            {projects &&
              projects.map((project: IProject) => (
                <tr key={project.id}>
                  <td id="actionsCell" className="cell-align-middle">
                    {this.props.appService.isProjectIdActive(project.id) ? (
                      <div>
                        <Button
                          bsStyle="primary"
                          bsSize="small"
                          className="button-right"
                          onClick={this.props.deactivateProject}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-minus-sign" />
                        </Button>
                        <Button
                          bsSize="small"
                          className="button-right"
                          bsStyle="success" // tslint:disable-next-line:jsx-no-lambda
                          onClick={() => this.props.editProject(project.id)}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-edit" /> Edit
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <Button
                          bsStyle="success"
                          bsSize="small"
                          className="button-right" // tslint:disable-next-line:jsx-no-lambda
                          onClick={() => this.props.activateProject(project.id, project.location)}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-plus-sign" />
                        </Button>
                        <Button
                          className="button-right"
                          bsStyle="primary"
                          bsSize="small"
                          // tslint:disable-next-line:jsx-no-lambda
                          onClick={() => this.props.copyProject(project.id, project.location)}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-copy" />
                        </Button>
                        <Button
                          className="button-right"
                          bsStyle="danger"
                          bsSize="small" // tslint:disable-next-line:jsx-no-lambda
                          onClick={() => this.props.deleteProject(project.id)}
                        >
                          <Glyphicon glyph="glyphicon glyphicon-remove" />
                        </Button>
                      </div>
                    )}
                  </td>
                  <td id="locationCell" className="cell-align-middle">
                    {project.location}
                  </td>
                  {/* <td>{project.id}</td> */}
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/Projects.tsx